
const appBarModule = {
    namespaced: true,
    state: {
        viewOpened: 'Mis trámites'
    },
    actions:{
        updateViewOpened({ commit }, val){
            commit('changeViewOpened', val)
        }
    },
    mutation: {
        changeViewOpened(state, view){
            state.viewOpened = view
        }
    }
}

export default appBarModule